export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200">
            <div className="flex-shrink-0 w-40 h-40 md:w-48 md:h-48 rounded-2xl overflow-hidden border-2 border-background-300">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20phone%20showing%20movie%20streaming%20app%20interface%20with%20colorful%20film%20posters%2C%20modern%20UI%20design%2C%20warm%20evening%20light%20on%20phone%20screen%2C%20cozy%20living%20room%20background%2C%20entertainment%20app%20concept%2C%20clean%20and%20vibrant%20design&width=500&height=500&seq=app-qr-2026&orientation=squarish"
                alt="6080新视觉影视移动端体验"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
                APP下载
              </h2>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-5">
                6080新视觉影视移动客户端，专为手机观影优化。更流畅的播放体验，
                更便捷的收藏功能，支持离线缓存，随时随地畅享高清影视。扫描二维码或在应用商店搜索下载。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-background-50 text-sm font-medium rounded-lg whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-fill text-lg"></i>
                  App Store
                </span>
                <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg whitespace-nowrap cursor-pointer">
                  <i className="ri-android-fill text-lg"></i>
                  安卓下载
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}